import {
  CreateCustomerPurchaseCommand,
  AppointmentQueueListParams,
  SnappPayEligibilityCommand,
} from "@/models/club";
import clubRequest, { silentErrors } from "../axios";

// Errors are shown by useCreateReviewedFactor, so the global error toast is skipped.
const createFactor = async (data: CreateCustomerPurchaseCommand, idempotencyKey?: string) =>
  (await clubRequest.customerPurchaseCreate(data, { ...silentErrors, headers: idempotencyKey ? { "Idempotency-Key": idempotencyKey } : undefined })).data;

const getAllAppointmentQueue = async (params: AppointmentQueueListParams) =>
  (await clubRequest.appointmentQueueList(params)).data;

const checkSnappPayEligibility = async (data: SnappPayEligibilityCommand) =>
  (await clubRequest.customerPurchaseSnappPayEligibilityCreate(data)).data;

const resendPaymentLinkSms = async (purchaseId: number) =>
  (await clubRequest.customerPurchasePaymentLinkResendCreate({ purchaseId })).data;

const retryPurchase = async (purchaseId: number) =>
  (await clubRequest.customerPurchaseRetryCreate({ purchaseId })).data;

// Asks SnappPay again about an attempt in discrepancy. It can take minutes, so no timeout is set.
// A 400 means "still unknown", not "failed"; the caller shows that message itself.
const inquirePurchasePayment = async (transactionId: string) =>
  (await clubRequest.publicPurchasePaymentInquiryCreate({ transactionId }, silentErrors)).data;

export {
  createFactor,
  getAllAppointmentQueue,
  checkSnappPayEligibility,
  resendPaymentLinkSms,
  retryPurchase,
  inquirePurchasePayment,
};
